import { useState } from "react"
import { useRefreshCalendarBookings } from "../useRefreshCalendarBookings"

const useGridModals = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false)
  const [selectedBookingId, setSelectedBookingId] = useState(null)
  const [isJournalModalOpen, setIsJournalModalOpen] = useState(false)
  const [selectedJournalDate, setSelectedJournalDate] = useState(null)

  const refreshCalendarBookings = useRefreshCalendarBookings()

  const openBookingModal = (id) => {
    setSelectedBookingId(id)
    setIsBookingModalOpen(true)
  }

  const closeBookingModal = () => {
    setIsBookingModalOpen(false)
    setSelectedBookingId(null)
  }

  const handleBookingCancelSuccess = () => {
    closeBookingModal()
    refreshCalendarBookings()
  }

  const openJournalModal = (date) => {
    setSelectedJournalDate(date)
    setIsJournalModalOpen(true)
  }

  const closeJournalModal = () => {
    setIsJournalModalOpen(false)
  }

  return {
    isBookingModalOpen,
    selectedBookingId,
    openBookingModal,
    closeBookingModal,
    handleBookingCancelSuccess,
    isJournalModalOpen,
    selectedJournalDate,
    openJournalModal,
    closeJournalModal,
  }
}

export default useGridModals
